// Define special output constants
export const CLEAR_OUTPUT = "__CLEAR__";
export const RESET_OUTPUT = "__RESET__";

// Storage key for localStorage
export const OUTPUT_STORAGE_KEY = "react-command-flow-output";
export const HISTORY_STORAGE_KEY = "react-command-flow-history";

export const defaultTranslations = {
  yes: "yes",
  no: "no",
  exitCommands: ["exit", "quit", "cancel"],
  backCommands: ["back"],
};
